import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Flacon = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.35 82.95">
  <G fill={color}>
    <Path d="M38.03,25.45l-3.71-6.12H6.03l-3.71,6.12c-1.52,2.51-2.32,5.41-2.32,8.4v46.11c0,1.66,1.34,3,3,3h34.35c1.66,0,3-1.34,3-3v-46.11c0-2.99-.8-5.89-2.32-8.4ZM28.2,65.94H12.15c-1.66,0-3-1.34-3-3s1.34-3,3-3h16.05c1.66,0,3,1.34,3,3s-1.34,3-3,3ZM28.2,41.09H12.15c-1.66,0-3-1.34-3-3s1.34-3,3-3h16.05c1.66,0,3,1.34,3,3s-1.34,3-3,3Z"/>
    <Path d="M31.49,3c0-1.66-1.34-3-3-3H11.86c-1.66,0-3,1.34-3,3v10.33h22.63V3Z"/>
  </G>
</Svg>
);
};

export default Flacon;
